import { Box, Typography } from '@mui/material';
import { PageBase } from '../../PageBase';
import { theme } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const DataUse = () => {
  const { t } = useTranslation('dataUse');
  const navigate = useNavigate();

  return (
    <PageBase title={t('title')} onBackClick={() => navigate(-1)} paddingInline={0}>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {t('section1_title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section1_subtitle')}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 400 }}>
            {t('section1_item1')}
          </Typography>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 400 }}>
            {t('section1_item2')}
          </Typography>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 400 }}>
            {t('section1_item3')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
        <Typography
          sx={{
            fontSize: '1.4rem',
            fontWeight: 600,
          }}
        >
          {t('section2_title')}
        </Typography>
        <Box sx={{ marginTop: 1.0 }}>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 400 }}>
            {t('section2_item1')}
          </Typography>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 400 }}>
            {t('section2_item2')}
          </Typography>
        </Box>
      </Box>
    </PageBase>
  );
};
